import { Image } from '@/shared/ui/Image'

import { CDN_SPLIT_IMG_URL } from '../../data'

import cls from './style.module.scss'

export const HeroBanner = () => (
	<section className={cls.root}>
		<div className={cls.root__content}>
			<Image width={223} height={32} src={`${CDN_SPLIT_IMG_URL}/yaSplitLogo.png`} alt="split logo" />
			<p className={cls.root__title}>Сплитуйте оплату на части</p>
			<p className={cls.root__subtitle}>Без переплат</p>
		</div>
		<div className={cls.root__img}>
			<Image width={528} height={344} src={`${CDN_SPLIT_IMG_URL}/heroImage.png`} alt="hero image" />
		</div>
	</section>
)
